import {CpcShoppingCartDiscountSchemeEndpointsApiService} from "@/main";
import {
    ShoppingCartDiscountSchemeOverviewRestDto,
    ShoppingCartDiscountSchemeRestDto,
} from "@/api/pharma-cpc-mgmt/models";

export default {
    state() {
        return {
            shopping_cart_discount_scheme: {} as ShoppingCartDiscountSchemeRestDto,
            shopping_cart_discount_schemes: [] as ShoppingCartDiscountSchemeOverviewRestDto[],
        };
    },
    actions: {
        async deleteShoppingCartDiscountScheme(context: any, id: string) {
            await CpcShoppingCartDiscountSchemeEndpointsApiService.deleteShoppingCartDiscountScheme(id);
        },
        async searchShoppingCartDiscountSchemes(context: any) {
            const response =
                await CpcShoppingCartDiscountSchemeEndpointsApiService.findShoppingCartDiscountSchemes(undefined);
            context.commit('setShoppingCartDiscountSchemes', response.data);
        },
    },
    mutations: {
        setShoppingCartDiscountSchemes(state: any, discount_schemes: ShoppingCartDiscountSchemeOverviewRestDto[]) {
            state.shopping_cart_discount_schemes = discount_schemes;
        },
    },
    getters: {
        getShoppingCartDiscountSchemes(state: any): ShoppingCartDiscountSchemeOverviewRestDto[] {
            return state.shopping_cart_discount_schemes;
        }
    },
}
